import { MenuRow, TMenuRow } from "../../gui/Menu/Menu";
import DateRangeFilter from "../widgets/DateRangeFilter";
import { usePath } from "../../libs/path/PathProvider";
import { Price } from "../../models/Price";
import Toolbar from "../widgets/Toolbar";
import {pull} from "lodash"
import Select from "../../gui/Select/Select";
import Checkbox from "../../gui/Button/Checkbox";
import { EAccountTypes, ValidTransactionTypes } from "../../shared/Consts";
import { ETransactionType } from "../../shared/ITransaction";
import { usePortFilter } from "../../hooks/PortFilter";
import usePortfolio from "../../hooks/PortfolioProvider";

export type TTransactionsToolbarProps = {
    search:string
    onSearch:(search:string) => void
    actions:ETransactionType[]
    setActions:(actions:ETransactionType[]) => void
    onExport:() => void
}
export default function TransanctionsToolbar(props:TTransactionsToolbarProps){
    const {hash} = usePath()
    const [_,ticker] = hash.split("/")
    const {actions,setActions: onActions} = props
    const isCash = Price.isCash(ticker)
    const {account} = usePortFilter()
    const {portfolio} = usePortfolio()

    const onAction = (action:ETransactionType) => () => {
        if (action==ETransactionType.all) actions.length = 0
        else if (actions.includes(action)) pull(actions, action)
        else actions.push(action)
        onActions([...actions])
    }
    const MenuOptions : TMenuRow<string|ETransactionType>[] = [
        {id:"add",text:isCash ? "Deposit/Withdraw" : "Acquisition", url:{hash:`/${ticker}/add`}},
        {id:"div",text:Price.isCash(ticker) ? "Interest/Adjust" : "Dividend", url:{hash:`/${ticker}/dividend`}},
        {id:"export",text:"Export", onClick:props.onExport},
        {id:"action",text:"Action", children:[
            {id:ETransactionType.all,text:"All"},
            {id:ETransactionType.buy,text:"Acquisition/Disposition"},
            {id:ETransactionType.dividend,text:"Dividend"},
            {id:ETransactionType.interest,text:"Interest"},
            {id:ETransactionType.adjust,text:"Adjustment"},
        ]}
    ]

    if (isCash) {
        const text = portfolio.account(account)?.type==EAccountTypes.credit ? "Payment" : "Transfer"
        MenuOptions.splice(1, 0, {id:"pay",text,url:{hash:`/${ticker}/xfer`}})
    }
    
    const itemRenderer = (option:TMenuRow<string|ETransactionType>) => {
        const id = Select.id(option)
        if (id==ETransactionType.all || ValidTransactionTypes.has(id as any)) {
            const type = id as ETransactionType
            const value = type==ETransactionType.all ? actions.length==0 : actions.includes(type)
            return <Checkbox value={value} onUpdate={onAction(type)}>{Select.text(option)}</Checkbox>
        }
        else return <MenuRow option={option}/>
    }
    
    if (!isCash) MenuOptions.push({id:"reinvest",text:"Reinvest",url:{hash:`/${ticker}/reinvest`}})
    if (Price.isGIC(ticker)) MenuOptions.push({id:"redeem",text:"Redeem",url:{hash:`/${ticker}/redeem`}})
    return <Toolbar options={MenuOptions} search={props.search} onSearch={props.onSearch} itemRenderer={itemRenderer}>
        <DateRangeFilter/>
    </Toolbar>
}